// Copyright (c) 2025 Deere & Company

import actions from '../../actions-list';

export const amountOfUseItemToUpdate = item => ({
    item,
    type: actions.UPDATE_TCSM_AMOUNT_OF_USE_ITEM_TO_UPDATE
});

export const commentsToDealerUpdate = comments => ({
    comments,
    type: actions.UPDATE_TCSM_AMOUNT_OF_USE_COMMENTS_TO_DEALER
});

export const internalDeereCommentsUpdate = comments => ({
    comments,
    type: actions.UPDATE_TCSM_AMOUNT_OF_USE_INTERNAL_DEERE_COMMENTS
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/amount-of-use-item-to-update.js